import React from 'react'
import { Platform } from 'react-native'

import NoSsr from 'app/components/base/NoSsr'
import Select, { SelectProps } from 'app/components/base/Select'
import Skeleton from 'app/components/base/Skeleton'

import withFacet, { FacetComponentProps } from '../components/withFacet'

export type SelectFilterProps = Omit<
  SelectProps,
  'onChange' | 'value' | 'variant'
> & {
  fixedPaperWidth?: boolean
  transformValue?: (value: any) => any
  removeEmptyOptions?: boolean
}

const SelectFilter: RFC<SelectFilterProps & FacetComponentProps> = ({
  multiple,
  label,
  filter: { values, options, onSelect, field },
  disabled,
  optionSettings,
  helperText,
  divider,
  fixedPaperWidth,
  transformValue = (v) => v,
  removeEmptyOptions = false,
  ...props
}) => {
  const value = multiple ? values : values[0]

  const handleChange = (v: any) => {
    const value = v?.target?.value || v

    onSelect(transformValue(value))
  }

  const hasCustomOptions =
    !!optionSettings?.loadOptions || !!optionSettings?.options

  const filteredOptions = removeEmptyOptions
    ? options.filter((option) => option.value !== '')
    : options

  return (
    <NoSsr fallback={<Skeleton sx={{ height: 78, ...props.sx }} />}>
      <Select
        label={label}
        helperText={helperText}
        divider={divider}
        value={value}
        multiple={multiple}
        variant={
          Platform.select({
            web: 'select',
            native: 'picker'
          }) as SelectProps['variant']
        }
        optionSettings={{
          key: ['filterOptions', field],
          unselectable: true,
          ...(!hasCustomOptions && {
            options: filteredOptions,
            optionLabel: 'value',
            optionValue: 'value'
          }),
          ...optionSettings
        }}
        {...(fixedPaperWidth && { PaperSx: { width: 280 } })}
        {...props}
        disabled={disabled}
        onChange={handleChange}
      />
    </NoSsr>
  )
}

export default withFacet<SelectFilterProps>(SelectFilter)
